export async function requestDislikeResource(id: number, type: ResourceType) {
  return http.post('/v1/like/dislike', {
    id,
    type
  })
}
